module.exports = __webpack_public_path__ + "img/goal.f50006a4.png";